module.exports = __webpack_public_path__ + "133adff8acf564df5728fc89b27fb81a.svg";